<div [classList]="containerClassToAplly() + '-global-message'">

  <app-notification></app-notification>

  <app-global-message class="sticky-top animated fadeInDown"></app-global-message>

  @if (showAppHeader()) {
  <app-header class="sticky-top header"></app-header>
  }

  @if (isShopComponent()) {
  <app-shop-bundle-list [class.cart-preview-showing]="showAppCartPreview()"></app-shop-bundle-list>
  }

  @if (isShopComponent()) {
  <app-shop-header [class.cart-preview-showing]="showAppCartPreview()"></app-shop-header>
  }


  @if (showAppCartPreview()) {
  <app-cart-preview class="cart-preview cart-preview-height-global-message" [class.offcanvas-opened]="isSidebarOpen()">
  </app-cart-preview>
  }

  <main class="main-container" appScrollToTop [class.header-showing-global-message]="showAppHeader()"
    [class.header-showing-hidden-sub-nav-global-message]="!shouldShowCategoriesBar()"
    [class.cart-preview-showing]="showAppCartPreview()" [class.mobile-main-container]="showMobileFooter()"
    [class.with-shop-nav-only]="isShopComponent()" [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </main>

  @if (showMobileFooter()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

  @if (hasSession() && !isInSignupFlow()) {
  <app-floating-donation-button></app-floating-donation-button>
  }

</div>